var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSalary(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2383 4H7.77096C4.83427 4 3 5.42094 3 8.03285V15.8932C3 18.5462 4.83427 20 7.77096 20H16.229C19.175 20 21 18.5708 21 15.9589V8.03285C21.0092 5.42094 19.1842 4 16.2383 4Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 12H19",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 12H5",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 13.3103C14.5 12.1724 13.5836 11.7414 12.41 11.4138V9.82759C12.8601 9.91379 13.2942 10.1207 13.664 10.4483L14.3553 9.43103C13.7605 8.93103 13.1495 8.67241 12.41 8.62069V8H11.7508V8.62069C10.5129 8.72414 9.74116 9.44828 9.74116 10.5172C9.74116 11.7586 10.754 12.1724 11.7508 12.5V14.1034C11.2042 14.0172 10.6736 13.7586 10.2717 13.3793L9.5 14.3793C10.0788 14.9483 10.8666 15.2759 11.7508 15.3276V16H12.41V15.3103C13.7283 15.1897 14.5 14.431 14.5 13.3103ZM10.963 10.4828C10.963 10.1207 11.2203 9.86207 11.7508 9.81034V11.2069C11.2363 11.0345 10.963 10.8448 10.963 10.4828ZM12.41 14.1034V12.7069C12.9887 12.8966 13.1977 13.0862 13.1977 13.4138C13.1977 13.7931 12.9405 14.0345 12.41 14.1034Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalary);
export default __webpack_public_path__ + "static/media/salary.ffdc058cf3b4bf70643bedf0f2438bd4.svg";
export { ForwardRef as ReactComponent };